import { Signal, batch, untracked } from "@suse-o11y/signal";

import { type Interval, isEqualTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { max } from "~/tools/max";
import { min } from "~/tools/min";

export class State {
	private readonly start = Signal<undefined | Time>(undefined, {
		equals: isEqualTime,
	});

	private readonly end = Signal<undefined | Time>(undefined, {
		equals: isEqualTime,
	});

	public readonly interval = Signal<undefined | Interval>((monitor) => {
		const start = this.start.read(monitor);
		const end = this.end.read(monitor);

		if (start == null || end == null || isEqualTime(start, end)) {
			return undefined;
		}

		return { start: min(start, end), end: max(start, end) };
	});

	public onBrushStart(timestamp: Time): void {
		this.start.write(timestamp);
	}

	public onBrushMove(timestamp: Time): void {
		if (untracked(this.start) != null) {
			this.end.write(timestamp);
		}
	}

	public onBrushEnd(): void {
		batch(() => {
			this.start.write(undefined);
			this.end.write(undefined);
		});
	}
}
